var Marionette = require('marionette');

module.exports = Marionette.ItemView.extend({

    onRender: Backbone.View.prototype.unwrap,

    initialize: function(options) {
        this.parent = options.parent;
        this.activeItem = null;
        this.id = null;
    },

    ui: {
        tbBtn: '.tb-btn'
    },

    events: {
        'click @ui.tbBtn' : function(e) {

            var $el = $(e.currentTarget),
                activeItem = $el.data('item');

            if ($el.hasClass('tb-ignore'))
                return; //ignore but allow to propagate.

            this.setActiveButton(activeItem);
        }
    },

    setActiveButton: function(dataAttrVal) {

        this.$('[data-item]').removeClass('active');
        this.$('[data-item="' + dataAttrVal + '"]').addClass('active');
        this.activeItem = dataAttrVal;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/toolbar/toolbar.js
 ** module id = 504
 ** module chunks = 0
 **/